import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { GroupedTeams } from 'src/app/core/utils/team-grouping.util';

@Component({
  selector: 'app-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss']
})

export class FilterDropdownComponent {
  @Input() label = '';
  @Input() icon = '';
  @Input() options: any[] | null = null;
  @Input() groupedOptions: GroupedTeams | null = null;
  @Input() displayFn: (option: any) => string = (option) => option?.label ?? option?.name ?? '';
  @Input() allLabel = 'All';
  @Input() selectedLabel = '';
  @Input() searchable = false;
  @Input() searchText = '';
  @Input() searchPlaceholder = 'Search...';
  // 'chip': compact pill (icon + name, or the picked value) used by the genre View all page.
  @Input() variant: 'card' | 'chip' = 'card';

  @HostBinding('class.fd-chip') get isChip(): boolean {
    return this.variant === 'chip';
  }

  @Output() optionSelect = new EventEmitter<any>();
  @Output() searchTextChange = new EventEmitter<string>();

  onSearchTextChange(value: string) {
    this.searchTextChange.emit(value);
  }

  select(option: any | null) {
    this.optionSelect.emit(option);
  }
}
